// =============================================================================
// src/config/deployment.js
// Which deployment this branch builds. The ONLY config file that differs per
// branch: '' on main, 'zs' on @deploy/zs-deploy. Never edit it on main.
// NOT from process.env, so a deployment cannot switch itself.
// =============================================================================

export const DEPLOYMENT = 'zs';
